module.exports = __webpack_public_path__ + "static/media/NA.c5e062fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NA.svg
// module id = 2222
// module chunks = 7